import { GeolocationDeniedTranslation } from '../../types/geolocationDenied.types';

export const geolocationDenied: GeolocationDeniedTranslation = {
  title: 'Geolocalização bloqueada',
  firstParagraph:
    'Ops, parece que você bloqueou o acesso à sua localização! Para continuar, será necessário permitir o compartilhamento dessa informação.',
  secondParagraph: {
    part1: 'Para habilitar sua localização, acesse as',
    siteSettings: 'Configurações do site',
    part2: ', clicando no ícone de cadeado localizado antes do endereço da plataforma. Na seção',
    permissions: 'Permissões',
    part3: ', deixe a opção de',
    location: 'Local',
    part4: 'como',
    allow: 'Permitir',
  },
  retry: 'Tentar novamente',
};

export default geolocationDenied;
